import { IAutomationAppComponent } from "../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel, SideviewPanel } from '../Scheduler';
import { ConfigurationPanel } from './ConfigurationPanel';
import { IoCalendarOutline } from "react-icons/io5";
import { ListPanel } from "../Scheduler/ListPanel";


export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: IoCalendarOutline,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    ListPanel: ListPanel,
    SideViewPanel: SideviewPanel,
    isSmartApp: true,
    /*createConfig:  {
        group: 'Functions',
        name: "Scheduler running on the cloud",
        description: "Controlled Scheduler",
        panel: OverviewPanel,
        defaultState: {   },
        defaultProperties: [
        ]
    },*/
}